import { Alert, Col, Icon, Input, Row, Tooltip, Upload } from 'antd';
import { FormattedMessage } from 'react-intl';
const { TextArea } = Input;
import QuickReplyButtons from 'components/QuickReplyButtons';
import { InfoCircleOutlined } from '@ant-design/icons';
import AudioRecorder from './AudioRecorder';

const MessageLayout = ({ state, setState, language }) => {
	const onChangeMessage = (e) => {
		const { value } = e.target;
		setState({ msg: value });
	};

	const selectButton = (label) => {
		setState({
			totalButtons: state.totalButtons.map((btn) =>
				btn.label === label ? { ...btn, selected: !btn.selected } : btn,
			),
		});
	};

	const dummyRequest = ({ onSuccess }) => {
		setTimeout(() => {
			onSuccess('ok');
		}, 0);
	};

	const beforeUpload = (file) => {
		if (file.size > 104857600) {
			setState({ maxFileSize: true });
		} else {
			setState({ maxFileSize: false });
		}

		const files = [file];
		setState({ files });
		resetTemplateList();
	};

	const removeFile = (file) => {
		const { files } = state;
		const newFiles = files.filter(function (ele) {
			return ele !== file;
		});

		setState({ files: newFiles });
	};

	return (
		<>
			<Row>
				<Col span={21} style={{ marginLeft: '-7px' }}>
					<TextArea
						placeholder={language.type_your_msg}
						allowClear
						id="msgText"
						onChange={onChangeMessage}
						value={state.msg}
						autoSize={{ minRows: 5 }}
					/>
				</Col>
				<AudioRecorder state={state} setState={setState} />
			</Row>

			<Col span={24}>
				<div style={{ padding: 5 }}>
					{state.showTemplateButtons && (
						<Row>
							<QuickReplyButtons
								totalButtons={state.totalButtons}
								onAddButton={(button) =>
									setState({
										totalButtons: [...state.totalButtons, button],
									})
								}
								onSelectButton={selectButton}
								language={language}
							/>
						</Row>
					)}

					{state.totalButtons.find((button) => button.selected) && (
						<div
							style={{
								display: 'flex',
								justifyContent: 'flex-start',
								alignItems: 'flex-end',
							}}
						>
							<span
								style={{
									fontSize: '14px',
									color: '#333',
									marginRight: '10px',
									alignSelf: 'flex-end',
								}}
							>
								{language.files_with_buttons}
							</span>
							<Tooltip title={<FormattedMessage id="files_with_buttons_tooltip" />}>
								<InfoCircleOutlined
									style={{
										color: '#08AAF2',
										fontSize: '16px',
										marginBottom: '3px',
									}}
								/>
							</Tooltip>
						</div>
					)}

					<Upload.Dragger
						name="files"
						customRequest={dummyRequest}
						fileList={state.files}
						beforeUpload={beforeUpload}
						showUploadList={{
							showDownloadIcon: false,
							downloadIcon: 'download',
							showRemoveIcon: true,
						}}
						onRemove={removeFile}
					>
						<p className="ant-upload-drag-icon">
							<Icon type="inbox" />
						</p>
						<p className="ant-upload-text">{language.files_text1}</p>
						<p className="ant-upload-hint">{language.files_text2}</p>
					</Upload.Dragger>
				</div>
			</Col>
			<Col span={24}>
				{state.maxFileSize === true ? (
					<div style={{ padding: 5 }}>
						<Alert
							message={<FormattedMessage id="warning_maximum_file_size" />}
							type="error"
							showIcon
						/>
					</div>
				) : (
					<></>
				)}
			</Col>
		</>
	);
};

export default MessageLayout;
